import styled from 'styled-components';

export const TechStackCard = styled.div`
    display: inline-block;
    background-color: ${({color}) => color};
    color: rgb(255, 255, 255);
    padding: 0.2rem 1rem;
    border-radius: 10px;
    font-weight: bold;
    border: 5px solid ${({color}) => color};
    @media(max-width: ${({theme}) => theme.breakpoints.mobile}){
        margin-right: 1rem;
        margin-bottom: 1rem;
        padding: 0.3rem 1rem;
    }
    @media(max-width: ${({theme}) => theme.breakpoints.tablet}){
        margin-right: 1rem;
        margin-bottom: 1rem;
        padding: 0.3rem 1rem;
    }

`
export const ProjectImageContainer = styled.div`
     display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    flex-direction: row;
    overflow: hidden;
    
`;



export const ProjectImage = styled.img`
    display: block;
    margin: auto; 
    max-width: 100%;
    max-height: 100%;
 object-fit: contain;


    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
     width: 90vw;
    max-width: 80%;
    margin-top: 2rem;
  }

    
`
export const StyledArrowLeft = styled.div`
  position: relative;
  top: 313px; /* Ubica la flecha debajo del slider */
  left: 80%;
  transform: translateX(-50%);
  cursor: pointer;
  font-size: 35px;
  color: white;
  z-index: 100;
`;

export const StyledArrowRight = styled.div`
  position: relative;
  bottom: 40.7px; /* Ubica la flecha debajo del slider */
  left: 70px;
  transform: translateX(50%);
  cursor: pointer;
  font-size: 35px;
  color: white;
 z-index: 100;
`;
export const FixedBorderContainer = styled.div`
    width: 100%;
    height: 110%;
    padding: 30px;
    border: 2px solid #ffff;
    border-radius: 10px; /* Bordes redondeados */
    display: flex;
    justify-content: center;
    align-items: center;

     @media(max-width: ${({theme}) => theme.breakpoints.tablet}){
       margin-right:70px;
       padding: 50px;
    }
`;

